import React from "react";
import {Alert, Button, Card, Form, Icon, Input, Modal, Select, Spin, Tooltip, message} from "antd";
import {getFormFieldByType, sanitizeFieldName} from "../../util/methods";
import {fetchMasterFilter} from "../../appRedux/actions";
import {connect} from "react-redux";
import SubList from "../SubList";
import {createResource as manpower} from "../../appRedux/actions/Manpower";
import {createResource as documentType} from "../../appRedux/actions/DocumentType";
import {createResource as location} from "../../appRedux/actions/Location";
import {createResource as client} from "../../appRedux/actions/Client";
import {createResource as assetType} from "../../appRedux/actions/AssetType";
import {createResource as interval} from "../../appRedux/actions/Interval";
import {createResource as jobType} from "../../appRedux/actions/JobType";
import {createResource as owner} from "../../appRedux/actions/Owner";
import {createResource as sparePart} from "../../appRedux/actions/SparePart";
import {createResource as sparePartType} from "../../appRedux/actions/SparePartType";
import {createResource as status} from "../../appRedux/actions/Status";
import {createResource as unitOfMeasurement} from "../../appRedux/actions/UnitOfMeasurement";
import {createResource as vendor} from "../../appRedux/actions/Vendor";
import {createResource as activityType} from "../../appRedux/actions/ActivityType";
import {createResource as fuelType} from '../../appRedux/actions/FuelType';
import {createResource as fuelReadingMethod} from '../../appRedux/actions/FuelReadingMethod';
import {createResource as conditionOfAsset} from '../../appRedux/actions/ConditionOfAsset';
import {createResource as labour} from '../../appRedux/actions/Labour';
import {createResource as assetSubType} from "../../appRedux/actions/EquipmentSubType";
import {createResource as assetMake} from "../../appRedux/actions/AssetMake";
import {createResource as assetClassification} from "../../appRedux/actions/AssetClassification";
import {createResource as subAssembly} from "../../appRedux/actions/SubAssembly";
import AccessControl from "../AccessControl";

let context;
// const obj = {
//   manpower: Manpower,
// };

class MasterModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modalOpen: 1,
      // documentData: [],
      visible: false,
      fields: {
        name: {
          value: '',
        },
        description: {
          value: ''
        }
      },
    };
  }

  componentDidMount() {
    context = this;
  }

  componentWillReceiveProps(nextProps) {
  }

  showModal = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const {item} = this.props;
    this.props.fetchMasterFilter(item);
    // this.props.fetchSubDocumentFilter('Document');
    this.setState({
      visible: true,
    });
  };
  handleCancel = e => {
    this.setState({
      visible: false,
    });
  };
  handleChange = (changedFields) => {
    this.setState(({fields}) => ({
      fields: {...fields, ...changedFields},
    }));
  };
  edit = (id) => {
  };
  // getDocumentData = (data) => {
  // this.setState({ documentData: data });
  // };
  handleSubmit = (e) => {
    const {match, item, loading, resource} = this.props;
    // console.log('props', item, this.props);
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if(err) {
        return console.log(err);
      }
      if (this.isAssetModelPopup()) {
        if (typeof values.modelNumber === 'string') {
          values.modelNumber = values.modelNumber.trim();
          if (!values.modelNumber) {
            delete values.modelNumber;
          }
        }
        const generatedName = this.getGeneratedAssetModelName(values, this.props.masterFilters);
        if (!generatedName) {
          message.error('Please select Asset Sub Type and Make to generate the Asset Model Name.');
          return;
        }
        values.name = generatedName;
      }
      switch (item) {
        case 'Manpower':
          if(this.props.subMaster) {
            this.props.manpower(values, false, resource, true);
          } else {
            if(this.props.superMaster) {
              this.props.manpower(values, false, resource, false, true);
            } else {
              this.props.manpower(values, false, resource, false);
            }
          }
          break;

        case 'Labour':
          this.props.labour(values, false, resource);
          break;

        case 'DocumentType':
          if(this.props.subMaster) {
            this.props.documentType(values, false, resource, true);
          } else {
            this.props.documentType(values, false, resource, false);
          }
          break;

        case 'Location':
          this.props.location(values, false, resource);
          break;

        case 'Client':
          this.props.client(values, false, resource);
          break;

        case 'AssetType':
          if(this.props.subMaster) {
            this.props.assetType(values, false, resource, true);
          } else {
            if(this.props.superMaster) {
              this.props.assetType(values, false, resource, false, true);
            } else {
              this.props.assetType(values, false, resource, false);
            }
          }
          break;

        case 'AssetClassification':
          if(this.props.subMaster) {
            this.props.assetClassification(values, false, resource, true);
          } else {
            if(this.props.superMaster) {
              this.props.assetClassification(values, false, resource, false, true);
            } else {
              this.props.assetClassification(values, false, resource, false);
            }
          }
          break;

        case 'EquipmentSubType' :
          // console.log(this.props);
          // this.props.assetSubType(values, false, resource, false);
          if(this.props.subMaster) {
            this.props.assetSubType(values, false, resource, true);
          } else {
            if(this.props.superMaster) {
              this.props.assetSubType(values, false, resource, false, true);
            } else {
              this.props.assetSubType(values, false, resource, false);
            }
          }
          setTimeout(() => {
            if(this.props.handleSelectAssetType && this.props.form2)
              this.props.handleSelectAssetType(this.props.form2.getFieldValue(`assetDetails[${this.props.index}]['assetType']`));
          }, 500);
          break;

        case 'AssetMake' :
          // this.props.assetMake(values, false, resource, false);
          if(this.props.subMaster) {
            this.props.assetMake(values, false, resource, true);
          } else {
            if(this.props.superMaster) {
              this.props.assetMake(values, false, resource, false, true);
            } else {
              this.props.assetMake(values, false, resource, false);
            }
          }
          break;

        case 'Interval':
          if(this.props.subMaster) {
            this.props.interval(values, false, resource, true);
          } else {
            if(this.props.superMaster) {
              this.props.interval(values, false, resource, false, true);
            } else {
              this.props.interval(values, false, resource, false);
            }
          }
          break;

        case 'JobType':
          this.props.jobType(values, false, resource);
          break;

        case 'Owner':
          if(this.props.subMaster) {
            this.props.owner(values, false, resource, true);
          } else {
            this.props.owner(values, false, resource, false);
          }
          break;

        case 'SparePart':
          this.props.sparePart(values, false, resource);
          break;

        case 'SparePartType':
          if(this.props.subMaster) {
            this.props.sparePartType(values, false, resource, true);
          } else {
            if(this.props.superMaster) {
              this.props.sparePartType(values, false, resource, false, true);
            } else {
              this.props.sparePartType(values, false, resource, false);
            }
          }
          break;

        case 'Status':
          this.props.status(values, false, resource);
          break;

        case 'UnitOfMeasurement':
          if(this.props.subMaster) {
            this.props.unitOfMeasurement(values, false, resource, true);
          } else {
            if(this.props.superMaster) {
              this.props.unitOfMeasurement(values, false, resource, false, true);
            } else {
              this.props.unitOfMeasurement(values, false, resource, false);
            }
          }
          break;

        case 'Vendor':
          this.props.vendor(values, false, resource);
          break;

        case 'ActivityType':
          if(this.props.subMaster) {
            this.props.activityType(values, false, resource, true);
          } else {
            this.props.activityType(values, false, resource, false);
          }
          break;

        case 'FuelType':
          this.props.fuelType(values, false, resource);
          break;

        case 'FuelReadingMethod':
          this.props.fuelReadingMethod(values, false, resource);
          break;

        case 'ConditionOfAsset':
          this.props.conditionOfAsset(values, false, resource);
          break;

        case 'SubAssembly':

          this.props.subAssembly(values, false, resource);
          break;

        default:
          break;
      }

      if(!loading) {
        this.setState({visible: false});
        this.props.form.resetFields();
      }
    });

  };

  isAssetModelPopup = () => this.props.item === 'AssetModel'

  getOptionNameById = (field, selectedId, filters = this.props.masterFilters) => {
    if (!selectedId || !filters || !filters[field]) {
      return '';
    }
    const selectedIdValue = `${selectedId}`;
    const options = filters[field] && filters[field].data && filters[field].data.data || [];
    const selectedOption = options.find((option) => `${option && option._id}` === selectedIdValue);
    return selectedOption && selectedOption.name || '';
  }

  composeAssetModelName = (assetMakeName = '', assetSubTypeName = '', modelNumber = '') => {
    const normalizedModelNumber = modelNumber && modelNumber.toString().trim() || '';
    const nameParts = [(assetMakeName || '').trim(), (assetSubTypeName || '').trim()];
    if (normalizedModelNumber) {
      nameParts.push(normalizedModelNumber);
    }
    return nameParts.filter(Boolean).join(' ');
  }

  getGeneratedAssetModelName = (values = {}, filters = this.props.masterFilters) => {
    const assetSubTypeName = this.getOptionNameById('assetSubType', values.assetSubType, filters);
    const assetMakeName = this.getOptionNameById('assetMake', values.assetMake, filters);
    return this.composeAssetModelName(assetMakeName, assetSubTypeName, values.modelNumber);
  }

  onAssetSubTypeChange = () => {
    this.props.form.setFieldsValue({assetMake: undefined});
  }

  renderInlineCreateButton = (fieldConfig = {}, fallbackItem = '') => {
    if (!fieldConfig || !fieldConfig.options || !fieldConfig.options.master) {
      return null;
    }
    const modalItem = fieldConfig.options.ref || fallbackItem;
    const {form, ...modalProps} = this.props;
    return <CreateForm {...modalProps} item={modalItem} title={'CREATE'} />;
  }

  getLabelWithTooltip = (fieldConfig = {}, fallback = '') => {
    const label = sanitizeFieldName(fieldConfig.options && fieldConfig.options.label ? fieldConfig.options.label : fallback);
    return (
      <span>
        {label}&nbsp;
        {fieldConfig.options && fieldConfig.options.description ? (
          <Tooltip title={fieldConfig.options.description}>
            <Icon type="question-circle-o" />
          </Tooltip>
        ) : null}
      </span>
    );
  }

  renderAssetModelNameSection = (filters = this.props.masterFilters, form = this.props.form) => {
    if (!filters || !filters.assetSubType || !filters.assetMake) {
      return null;
    }
    const {getFieldDecorator} = form;
    const generatedName = this.getGeneratedAssetModelName({
      assetSubType: form.getFieldValue('assetSubType'),
      assetMake: form.getFieldValue('assetMake'),
      modelNumber: form.getFieldValue('modelNumber'),
    }, filters);
    const modelNumberFilter = filters.modelNumber || {field: 'modelNumber', required: false, options: {label: 'Model Number'}};

    return (
      <div style={{padding: '12px 12px 0 12px', marginBottom: 12, border: '1px solid #d9f7be', borderRadius: 6, background: '#fafafa'}}>
        <Alert
          type="info"
          showIcon
          message="Asset Model Name is generated automatically in the background"
          description="Sequence: Asset Sub Type -> Make -> Model Number (optional)."
          style={{marginBottom: 12}}
        />

        <Form.Item key={'assetSubType'} label={this.getLabelWithTooltip(filters.assetSubType, 'assetSubType')}>
          <div style={{display: 'flex', alignItems: 'center'}}>
            {getFieldDecorator('assetSubType', {
              rules: [{
                required: filters.assetSubType.required,
                message: `${sanitizeFieldName(filters.assetSubType.options && filters.assetSubType.options.label ? filters.assetSubType.options.label : 'assetSubType')} is required!`
              }],
            })(<Select
              showSearch
              allowClear
              style={{width: '80%'}}
              placeholder="Please select Asset Sub Type"
              onChange={this.onAssetSubTypeChange}
              filterOption={(input, option) =>
                (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
              }
            >
              {(filters.assetSubType.data && filters.assetSubType.data.data || []).map((option) =>
                <Select.Option key={option._id} value={option._id}>{option.name}</Select.Option>)}
            </Select>)}
            {this.renderInlineCreateButton(filters.assetSubType, 'EquipmentSubType')}
          </div>
        </Form.Item>

        <Form.Item key={'assetMake'} label={this.getLabelWithTooltip(filters.assetMake, 'assetMake')}>
          <div style={{display: 'flex', alignItems: 'center'}}>
            {getFieldDecorator('assetMake', {
              rules: [{
                required: filters.assetMake.required,
                message: `${sanitizeFieldName(filters.assetMake.options && filters.assetMake.options.label ? filters.assetMake.options.label : 'assetMake')} is required!`
              }],
            })(<Select
              showSearch
              allowClear
              style={{width: '80%'}}
              placeholder="Please select Make"
              disabled={!form.getFieldValue('assetSubType')}
              filterOption={(input, option) =>
                (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
              }
            >
              {(filters.assetMake.data && filters.assetMake.data.data || []).map((option) =>
                <Select.Option key={option._id} value={option._id}>{option.name}</Select.Option>)}
            </Select>)}
            {this.renderInlineCreateButton(filters.assetMake, 'AssetMake')}
          </div>
        </Form.Item>

        <Form.Item key={'modelNumber'} label={this.getLabelWithTooltip(modelNumberFilter, 'modelNumber')}>
          {getFieldDecorator('modelNumber', {
            rules: [{required: false}],
          })(<Input placeholder={`Please Enter ${sanitizeFieldName(modelNumberFilter.field || 'modelNumber')}`} autoComplete={'off'} />)}
        </Form.Item>

        <Form.Item key={'generatedName'} label="Generated Asset Model Name">
          <Input value={generatedName || 'Will be generated after selecting Asset Sub Type and Make'} disabled />
        </Form.Item>
      </div>
    );
  }

  render() {
    const {
      item,
      isDisabled,
      masterFilters,
      data,
      history,
      match,
      title,
      loading,
      form,
      resource,
      authUser
    } = this.props;
    // console.log('=> ',item);
    const {getFieldDecorator} = form;
    const {visible} = this.state;
    const isAssetModelPopup = this.isAssetModelPopup();
    const hiddenAssetModelFields = ['name', 'assetSubType', 'assetMake', 'modelNumber'];
    const masterFilterKeys = Object.keys(masterFilters || {}).filter((itm) => !(isAssetModelPopup && hiddenAssetModelFields.includes(itm)));
    return (
      <span style={{width: '20%', display: 'inline-block'}}>
        <Modal
          title={`Create ${item === 'Client' ? 'Sub Location' : item === 'Interval' ? 'Meter Unit' : item}`}
          visible={visible}
          onOk={this.handleOk}
          onCancel={this.handleCancel}
          footer={null}
        >
          <Spin spinning={loading}>
            <Card className={`gx-card-metrics`}
                  title={`${title} ${sanitizeFieldName(item === 'Client' ? 'subLocation' : item === 'Interval' ? 'meterUnit' : item)}`}>
              <Form onSubmit={this.handleSubmit} layout="vertical">
                {isAssetModelPopup ? this.renderAssetModelNameSection(masterFilters, form) : null}

                {masterFilterKeys.map((itm) => {
                  if(masterFilters[itm].type === 'Array' && masterFilters[itm].schema && this.props.hide && this.props.hide !== true) {
                    return <SubList key={itm} item={masterFilters[itm]} form={form} data={[]} title={title}
                                    resource={resource}/>
                  } else {
                    if(masterFilters[itm].type === 'Array' && masterFilters[itm].options.ref === 'Document') {
                      // return <DocumentList match={this.props.match} history={this.props.history} key={itm} item={masterFilters[itm]} form={form} data={[]} subDocumentFilters={subDocumentFilters} getDocumentData={this.getDocumentData}/>
                    }
                    return getFormFieldByType(masterFilters, itm, getFieldDecorator, {}, {resource: item, pvModule: this.props.pvModule || false})
                  }
                })}

                <Form.Item>
                  <Button type="primary" className="gx-mb-0" htmlType="button" onClick={this.handleSubmit}
                          loading={loading}>
                    CREATE
                  </Button>
                </Form.Item>
              </Form>
            </Card>
          </Spin>

        </Modal>
        {
          this.props && this.props.disableAll ? <AccessControl resource={item} permissionNeeded={'c'}
                                                               roles={authUser ? authUser.roles : []}
                                                               render={(props) => {
                                                                 return <Button disabled={true} type="dashed"
                                                                                onClick={this.showModal}
                                                                                className={'master-modal-new-btn'}
                                                                                style={{
                                                                                  margin: '0',
                                                                                  marginTop: '0',
                                                                                  marginLeft: '10px',
                                                                                  width: 'calc(100% - 10px)'
                                                                                }}>{this.props.buttonText || 'New'}</Button>
                                                               }}/> :
            <AccessControl resource={item} permissionNeeded={'c'}
                           roles={authUser ? authUser.roles : []} render={(props) => {
              return <Button type="dashed" onClick={this.showModal} className={'master-modal-new-btn'} style={{
                margin: '0',
                marginTop: '0',
                marginLeft: '10px',
                width: 'calc(100% - 10px)'
              }}>{this.props.buttonText || 'New'}</Button>
            }}/>
        }
      </span>
    )
  }
}

const mapStateToProps = ({commonData, auth}) => {
  return {
    authUser: auth.authUser,
    masterFilters: commonData.masterFilters,
    // subDocumentFilters: commonData.subDocumentFilters,
    loading: commonData.loading,
  }
};

function mapDispatchToProps(dispatch) {
  return {
    fetchMasterFilter,
    manpower,
    documentType,
    location,
    client,
    assetType,
    interval,
    jobType,
    owner,
    sparePart,
    sparePartType,
    status,
    unitOfMeasurement,
    vendor,
    activityType,
    fuelType,
    fuelReadingMethod,
    conditionOfAsset,
    labour,
    assetSubType,
    assetMake,
    subAssembly,
    assetClassification,
    // fetchSubDocumentFilter
  };
}

const CreateForm = Form.create({
  name: 'global_state',
  onFieldsChange(props, changedFields) {
    context.handleChange(changedFields);
  }
})(MasterModal);


export default connect(mapStateToProps, mapDispatchToProps())(CreateForm);
